import { Helmet } from 'react-helmet';
import Activities from 'src/features/Activities';
import MainLayout from 'src/layouts';

const ActivitiesPage = () => {
  return (
    <MainLayout>
      <Helmet title="Activities" />
      <Activities />
    </MainLayout>
  );
};

export default ActivitiesPage;
